import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Link } from "react-router-dom";
import { useParams, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import * as Tooltip from '@radix-ui/react-tooltip';

import { toggleDiagramDetails, toggleModalLanguages } from '../../../redux/main/main.actions';
import { toggleModalDiagramExportSQL, enableExportImageClick } from '../../../redux/diagram/diagram.actions';

// eslint-disable-next-line
import {
    updateScaleToFit,
    toggleBtnSearch,
    toggleBtnLeftPanel,
    toggleBtnRedGreenView,
    toggleBtnViewModes,
    clickEscape,
    setElementsViewMode,
    setNewPenColor,
    setNewPenWidth,
    clearNewPen,
    toggleBtnExport,
    toggleBtnExportImage,
    toggleBtnExportCode,
    toggleBtnSqlSyntax,
    setSqlSyntax,
    toggleBtnSettings,
    toggleBtnModalShortcuts,
} from '../../../redux/diagram/diagram.actions';
import {
    // CONTROLS: LEFT PANEL | SEARCH | EXPORT
    selectIsBtnSettingsEnabled,


    // list of controls to disable shortcuts
    selectIsBtnRedGreenViewEnabled,
    selectIsBtnLeftPanelEnabled,
    selectIsBtnSearchEnabled,
    selectIsBtnExportImageEnabled,
    // selectIsBtnExportCodeEnabled,

    selectIsBtnExportEnabled,
    selectIsBtnExportCodeEnabled,

    selectIsBtnSqlSyntaxEnabled,
    selectDiagramDbEngine,


    // CONTROLS: PEN
    selectIsBtnPenEnabled,

    // CONTROLS: VIEW MODES
    selectIsBtnViewModesEnabled,

    selectIsBtnPopupNewsEnabled,

    // CONTROLS: PRS | VIEW MODES
    selectViewMode,
    selectFocusedInsideElement,
    selectNewPenProps,

    selectElements,
    selectIsEnabledElementDescriptionEditing,

    selectDiagramDetails,
} from '../../../redux/diagram/diagram.selectors';

import {
    selectIsModalSupportEnabled,
    selectIsModalDiagramDetailsEnabled,
    selectIsModalDiagramShareEnabled,
} from '../../../redux/main/main.selectors';


// eslint-disable-next-line
import {
    BackgroundColorCircleBigIcon,
    IconBack,
    // LeftPanelOpenIcon,
    AutoLayoutIcon,
    ChangeRequestIcon,
    ExportIcon,
    // LeftSidebarOpenedIcon,
    LeftSidebarClosedIcon,
    FitToZoomIcon,
    SearchIcon,
    ViewModeIcon,
    LogoIcon,
} from '../../Icon';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';
import { useDeviceType } from '../../../hooks/useDeviceType.ts';

import './ControlsTopLeft.scss';


function buildDbEngineName(value = '') {
    switch (value) {
        case 'basicsql':
            return 'Basic SQL';
        case 'mysql':
            return 'MySQL';
        case 'postgresql':
            return 'PostgreSQL';
        case 'sqlserver':
            return 'SQL Server';
        case 'oracle':
            return 'Oracle';
        case 'sqlite':
            return 'SQLite';
        case 'mariadb':
            return 'MariaDB';
        default:
            return 'General SQL';
    }
}

export const ControlsTopLeft = () => {
    const history = useHistory();
    const { diagramId } = useParams();  // отримаємо ID діаграми з URL

    const { isDesktop } = useDeviceType(); // mobile/tablet => false

    const { t, i18n } = useTranslation();

    const { map: shortKeysMap, isMac } = useShortKeysNavigation();

    const handleClick = () => {
        setTimeout(() => {
            history.push(`/`);
        }, 100);
    };

    const dispatch = useDispatch();
    // eslint-disable-next-line
    const isBtnRedGreenViewEnabled = useSelector(
        selectIsBtnRedGreenViewEnabled
    );

    const isBtnSearchEnabled = useSelector(selectIsBtnSearchEnabled);
    const isBtnLeftPanelEnabled = useSelector(selectIsBtnLeftPanelEnabled);

    const isModalSupportEnabled = useSelector(selectIsModalSupportEnabled);
    const isModalDiagramDetailsEnabled = useSelector(selectIsModalDiagramDetailsEnabled);
    const isModalDiagramShareEnabled = useSelector(selectIsModalDiagramShareEnabled);


    const isBtnPopupNewsEnabled = useSelector(selectIsBtnPopupNewsEnabled);

    const newPenProps = useSelector(selectNewPenProps);

    const diagramDetails = useSelector(selectDiagramDetails);
    const diagramDbEngine = useSelector(selectDiagramDbEngine);

    const elementsRedux = useSelector(selectElements);
    // elements, updates from/to redis store value
    const elementsRef = useRef({});

    const searchBtnRef = useRef(null);
    const searchMenuRef = useRef(null);

    const isBtnViewModesEnabled = useSelector(selectIsBtnViewModesEnabled);
    const viewMode = useSelector(selectViewMode);
    const viewModesBtnRef = useRef(null);
    const viewModesMenuRef = useRef(null);

    const isBtnPenEnabled = useSelector(selectIsBtnPenEnabled);
    const penMenuRef = useRef(null);

    const isBtnExportEnabled = useSelector(selectIsBtnExportEnabled);
    const exportBtnRef = useRef(null);
    const exportMenuRef = useRef(null);

    const isBtnExportImageEnabled = useSelector(selectIsBtnExportImageEnabled);
    const exportImageMenuRef = useRef(null);

    const isBtnExportCodeEnabled = useSelector(selectIsBtnExportCodeEnabled);
    const exportCodeMenuRef = useRef(null);

    const isBtnSqlSyntaxEnabled = useSelector(selectIsBtnSqlSyntaxEnabled);
    // const sqlSyntax = useSelector(selectSqlSyntax);
    const sqlSyntaxBtnRef = useRef(null);
    const sqlSyntaxMenuRef = useRef(null);

    const isBtnSettingsEnabled = useSelector(selectIsBtnSettingsEnabled);
    const settingsBtnRef = useRef(null);
    const settingsMenuRef = useRef(null);


    const focusedInsideElementRedux = useSelector(selectFocusedInsideElement);

    const isEnabledElementDescriptionEditing = useSelector(selectIsEnabledElementDescriptionEditing);

    // useEffect(() => {
    //     const title = diagramDetails?.title || 'Untitled';
    //     document.title = `${title} | DB Design`;
    // }, [diagramDetails]);

    useEffect(() => {
        const handleKeyPress = (event) => {
            const isCtrl = isMac ? event.metaKey : event.ctrlKey;

            const isOpenTextEditing = focusedInsideElementRedux || isEnabledElementDescriptionEditing;
            const isTextEditing =
                isOpenTextEditing ||
                isModalDiagramDetailsEnabled ||
                isModalSupportEnabled ||
                isModalDiagramShareEnabled ||
                isBtnSearchEnabled ||
                isBtnExportImageEnabled;

            // Ignore events from disabled or read-only elements
            if (event.target.disabled || event.target.readOnly) return;

            if (isTextEditing) {
                // [Ctrl + F]
                if (
                    event.code === 'KeyF' && isCtrl &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                // [ESC]
                else if (event.code === 'Escape') {
                    event.preventDefault();
                    // console.log('Controls Top Left 1 Escape')

                    dispatch(clickEscape());
                }
                // } else if (isBtnExportImageEnabled) {
                //     // [Ctrl + F]
                //     if (
                //         event.code === 'KeyF' && isCtrl &&
                //         !event.altKey &&
                //         !event.shiftKey
                //     ) {
                //         event.stopPropagation();
                //         event.preventDefault();
                //     }

                //     // [ E ]
                //     else if (
                //         event.code === 'KeyE' &&
                //         !event.ctrlKey &&
                //         !event.metaKey &&
                //         !event.altKey &&
                //         !event.shiftKey
                //     ) {
                //         event.preventDefault();
                //         // dispatch(toggleBtnExport());
                //         dispatch(toggleBtnExportImage());
                //     }

                //     // [ESC]
                //     else if (event.code === 'Escape') {
                //         event.preventDefault();
                //         // console.log('Controls Top Left 1 Escape')

                //         dispatch(clickEscape());
                //     }
            } else if (isBtnPenEnabled) {
                // -----------------------------------------------------------------------------
                // +/- [DELETE] = [CLEAR NEW DRAWING PEN]
                if (
                    event.code === 'Delete' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.shiftKey &&
                    !event.altKey
                ) {
                    event.preventDefault();
                    dispatch(clearNewPen());
                }

                // [ESC]
                else if (event.code === 'Escape') {
                    event.preventDefault();
                    console.log('Controls Top Left 2 Escape')

                    dispatch(clickEscape());
                }
            } else {
                // // [ B ]
                // if (
                //     event.code === 'KeyB' &&
                //     !event.ctrlKey &&
                //     !event.metaKey &&
                //     !event.altKey &&
                //     !event.shiftKey
                // ) {
                //     event.preventDefault();
                //     dispatch(toggleBtnLeftPanel());

                //     // dispatch(handleVKey());
                // }
                // // [Ctrl + F] or [ F ] or [ S ]
                // else if (
                if (
                    event.code === 'KeyF' && isCtrl &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.stopPropagation();
                    event.preventDefault();
                    // dispatch(toggleBtnSearch());
                }
                // [ E ]
                else if (
                    event.code === 'KeyE' &&
                    !event.ctrlKey &&
                    !event.metaKey &&
                    !event.altKey &&
                    !event.shiftKey
                ) {
                    event.preventDefault();
                    // dispatch(toggleBtnExport());
                    dispatch(toggleBtnExportImage());
                }
                // // [ R ]
                // else if (
                //     event.code === 'KeyR' &&
                //     !event.ctrlKey &&
                //     !event.metaKey &&
                //     !event.altKey &&
                //     !event.shiftKey
                // ) {
                //     event.preventDefault();
                //     dispatch(toggleBtnRedGreenView());
                // }
                // [ESC]
                else if (event.code === 'Escape') {
                    event.preventDefault();
                    // console.log('Controls Top Left 3 Escape')

                    dispatch(clickEscape());
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [
        dispatch,
        isBtnPenEnabled,
        isModalSupportEnabled,
        isModalDiagramShareEnabled,
        isModalDiagramDetailsEnabled,
        focusedInsideElementRedux,
        isBtnLeftPanelEnabled,
        isBtnSearchEnabled,

        isBtnExportEnabled,
        isBtnExportImageEnabled,
        isBtnExportCodeEnabled,

        isBtnSqlSyntaxEnabled,

        isBtnRedGreenViewEnabled,
        isEnabledElementDescriptionEditing,

        isBtnSettingsEnabled,
    ]);

    // search menu
    const getSearchMenu = (isBtnSearchEnabled) => {
        if (!isBtnSearchEnabled) {
            return;
        }

        return (
            <div
                className={`search-group ${isBtnLeftPanelEnabled ? 'with-left-panel' : ''
                    }`}
                ref={searchMenuRef}
            >
                <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                        ></button>
                    </div>

                    <div className="control-divider"></div>
                </div>
                <div
                    className="control-divider"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        borderRadius: '5px',
                        height: '1px',
                        overflow: 'hidden',
                        boxShadow: 'none',
                        pointerEvents: 'auto',
                        backgroundColor: 'grey',
                    }}
                ></div>
            </div>
        );
    };

    // view modes menu
    const getViewModesMenu = (isBtnViewModesEnabled) => {
        if (!isBtnViewModesEnabled) {
            return;
        }
        if (!viewModesBtnRef.current) {
            return;
        }

        const rect = viewModesBtnRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 1;
        const left = rect.left + window.scrollX - 44.5;

        return (
            <div
                className={`view-modes-group`}
                ref={viewModesMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button control-button-option ${viewMode === 'full' ? 'selected' : ''
                                }`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setElementsViewMode('full'));
                            }}
                        >
                            {t('dropdown_ctrl_view_modes.full')}
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option ${viewMode === 'keys' ? 'selected' : ''
                                }`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setElementsViewMode('keys'));
                            }}
                        >
                            {t('dropdown_ctrl_view_modes.keys_only')}
                        </button>
                    </div>

                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled ${viewMode === 'names' ? 'selected' : ''}`}
                            // className={`control-button ${viewMode === 'names' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setElementsViewMode('names'));
                            }}
                        >
                            {t('dropdown_ctrl_view_modes.names_only')}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // pen menu
    const getPenMenu = (isBtnPenEnabled) => {
        if (!isBtnPenEnabled) {
            return;
        }

        return (
            <div className={`pen-menu-group`} ref={penMenuRef}>
                <div className="controls-group colors">
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'yellow' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setNewPenColor('yellow'));
                            }}
                        >
                            <BackgroundColorCircleBigIcon
                                color={'#ffc65e'}
                                isSelected={newPenProps.color === 'yellow'}
                            />
                        </button>
                    </div>
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'red' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setNewPenColor('red'));
                            }}
                        >
                            <BackgroundColorCircleBigIcon
                                color={'red'}
                                isSelected={newPenProps.color === 'red'}
                            />
                        </button>
                    </div>
                    <div className="control">
                        <button
                            className={`control-button circle-button ${newPenProps.color === 'lightgreen' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(setNewPenColor('lightgreen'));
                            }}
                        >
                            <BackgroundColorCircleBigIcon
                                color={'lightgreen'}
                                isSelected={newPenProps.color === 'lightgreen'}
                            />
                        </button>
                    </div>
                </div>

                {/* <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button small disabled ${viewMode === 'keys' ? 'selected' : ''
                                }`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setNewPenWidth(2));
                            }}
                        >
                            -------o--------------
                        </button>
                    </div>
                </div> */}

                <div className="controls-group">
                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={1000} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button small hovered clear-button`}
                                    type="button"
                                    // title=""
                                    // aria-label="Color"
                                    aria-pressed="false"
                                    onClick={() => {
                                        dispatch(clearNewPen());
                                    }}
                                >
                                    {t('b.clear')}
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls tooltip-back-link wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('b.clear')}</span>
                                <span className="tooltip-shortcut">Del</span>

                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
        );
    };

    // export image menu
    const getExportImageMenu = (isBtnExportImageEnabled) => {
        if (!isBtnExportImageEnabled) {
            return;
        }

        if (!exportBtnRef.current) {
            return;
        }

        const rect = exportBtnRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 1;

        // const left = rect.left + window.scrollX + 19 - 80 - 6;
        const left = 10;


        return (
            <div
                className={`export-image-group`}
                ref={exportImageMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className='export-image-title'>{t('m_export_img.title')}</div>

                <div className="controls-group-new">
                    <div className="control-new">
                        <button
                            className={`control-button-new`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >{t('b.cancel')}</button>
                    </div>

                    <div className="control-new">
                        <button
                            className={`control-button-new primary`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(enableExportImageClick());
                            }}
                        >{t('b.export')}</button>
                    </div>
                </div>
            </div>
        );
    };

    // export code menu
    const getExportCodeMenu = (isBtnExportCodeEnabled) => {
        if (!isBtnExportCodeEnabled) {
            return;
        }
        if (!exportBtnRef.current) {
            return;
        }

        const rect = exportBtnRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 47 + 1 + 1;
        // const left = rect.left + window.scrollX + 99;

        let left = rect.left + window.scrollX + 99 + 5;
        left =
            ['de', 'tr'].includes(i18n.language)
                ? left + 15
                : ['es', 'fr', 'pt_BR'].includes(i18n.language)
                    ? left + 16
                    : i18n.language === 'pl'
                        ? left + 4
                        : i18n.language === 'ja'
                            ? left + 24
                            : i18n.language === 'it'
                                ? left + 13
                                : left;
        return (
            <div
                className={`export-code-group`}
                ref={exportCodeMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => { dispatch(toggleModalDiagramExportSQL('mysql')) }}
                        >
                            MySQL
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => { dispatch(toggleModalDiagramExportSQL('postgresql')) }}
                        >
                            PostgreSQL
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => { dispatch(toggleModalDiagramExportSQL('sqlserver')) }}
                        >
                            SQL Server
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => { dispatch(toggleModalDiagramExportSQL('oracle')) }}
                        >
                            Oracle
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => { dispatch(toggleModalDiagramExportSQL('mariadb')) }}
                        >
                            MariaDB
                        </button>
                    </div>

                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                        // onClick={() => { dispatch(toggleModalDiagramExportSQL('sqlite')) }}
                        >
                            SQLite
                        </button>
                    </div>


                    {/* NOT USED NOW */}
                    {/* <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            IBM Db2
                        </button>
                    </div>

                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            Databricks
                        </button>
                    </div>

                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            Snowflake
                        </button>
                    </div>

                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            BigQuery
                        </button>
                    </div> */}


                    {/* <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            Redshift
                        </button>
                    </div>  */}
                </div>

                {/* <div className="control-divider-horizontal"></div> */}

                {/* <div className="controls-group">
                    <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(clickEscape());
                            }}
                        >
                            ORMs
                        </button>
                    </div>
                </div> */}
            </div>
        );
    };

    // export menu
    const getExportMenu = (isBtnExportEnabled) => {
        if (!isBtnExportEnabled) {
            return;
        }

        if (!exportBtnRef.current) {
            return;
        }

        const rect = exportBtnRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 1;
        // const left = rect.left + window.scrollX - 55;

        let left = rect.left + window.scrollX + 19 - 80;
        left =
            ['de', 'tr'].includes(i18n.language)
                ? left - 26
                : ['es', 'fr', 'pt_BR'].includes(i18n.language)
                    ? left - 15
                    : i18n.language === 'pl'
                        ? left - 7
                        : i18n.language === 'ja'
                            ? left - 32
                            : i18n.language === 'it'
                                ? left - 10
                                : left;

        return (
            <div
                className={`export-group`}
                ref={exportMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(toggleBtnExportImage());
                            }}
                        >
                            {t('dropdown_ctrl_export.export_img')}
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button control-button-option code ${isBtnExportCodeEnabled ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                dispatch(toggleBtnExportCode());
                            }}
                        >
                            {t('dropdown_ctrl_export.export_code')}
                            <svg width="18px" height="18px" fill="none" viewBox="0 -2 24 24" stroke="#8e94afb3" strokeWidth="2.6px" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px' }}><path d="m9 18 6-6-6-6"></path></svg>
                        </button>
                    </div>

                    {/* <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(toggleBtnExportCode());
                            }}
                        >
                            Export Document
                        </button>
                    </div> */}

                    {/* <div className="control">
                        <button

                            className={`control-button `}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(toggleBtnExportCode());
                            }}
                        >
                            Generate Sample Data
                        </button>
                    </div> */}

                </div>
            </div>
        );
    };



    // settings menu
    const getSettingsMenu = (isBtnSettingsEnabled) => {
        if (!isBtnSettingsEnabled) {
            return;
        }

        if (!settingsBtnRef.current) {
            return;
        }

        const rect = settingsBtnRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 1;
        // const left = rect.left + window.scrollX - 55;
        const left = rect.left + window.scrollX - 5;

        return (
            <div
                className={`settings-group`}
                ref={settingsMenuRef}
                style={{ top: `${top}px`, left: `${left}px` }}
            >
                <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button control-button-option`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={() => {
                                handleClick();
                            }}
                        >
                            {/* {t('dropdown_ctrl_settings.back_home')} */}
                            Back Home
                        </button>
                    </div>

                    {/* <div className="control">
                        <button
                            disabled
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(toggleBtnExportCode());
                            }}
                        >
                            Move on Scroll
                        </button>
                    </div> */}

                    {isDesktop ?
                        <React.Fragment>
                            <div className="control-divider"></div>

                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    style={{ fontSize: '24px', fontWeight: 700 }}
                                // onClick={() => {
                                //     dispatch(toggleBtnSettings())
                                //     setTimeout(() => { window.open('https://playground.dbdesign.io/new', '_blank'); }, 100)
                                // }}
                                >
                                    {t('dropdown_ctrl_settings.new_project')}
                                </button>
                            </div>

                            <div className="control-divider"></div>

                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    title=""
                                    aria-label="Color"
                                    aria-pressed="false"
                                    style={{ fontSize: '24px', fontWeight: 700 }}
                                    onClick={() => {
                                        dispatch(toggleBtnModalShortcuts());
                                    }}
                                >
                                    {t('dropdown_ctrl_settings.keyboard_shortcuts')}
                                </button>
                            </div>

                            {/* <div className="control">
                                <button
                                    className={`control-button control-button-option ${isBtnModalShortcutsEnabled ? 'selected' : ''}`}
                                    type="button"
                                    title=""
                                    aria-label="Color"
                                    aria-pressed="false"
                                    onClick={() => { dispatch(toggleBtnModalShortcuts()) }}
                                >
                                    Onboarding
                                </button>
                            </div>
 */}

                            <div className="control">
                                <button
                                    className={`control-button control-button-option`}
                                    type="button"
                                    title=""
                                    aria-label="Color"
                                    aria-pressed="false"
                                    onClick={() => {
                                        dispatch(toggleModalLanguages());
                                        dispatch(toggleBtnSettings());
                                    }}
                                >
                                    {t('dropdown_ctrl_settings.languages')}
                                </button>
                            </div>

                        </React.Fragment>
                        : ''}
                    {/*
                    <div className="control">
                        <button
                            className={`control-button `}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(toggleBtnExportCode());
                            }}
                        >
                            Hide Controls
                        </button>
                    </div> */}

                    {/* <div className="control">
                        <button
                            className={`control-button control-button-option disabled`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                        // onClick={() => {
                        //     dispatch(toggleBtnExportCode());
                        // }}
                        >
                            Show Grid
                        </button>
                    </div> */}


                </div>
            </div>
        );
    };

    // export menu
    const getSqlSyntaxMenu = (isBtnSqlSyntaxEnabled) => {
        if (!isBtnSqlSyntaxEnabled) {
            return;
        }

        if (!sqlSyntaxBtnRef.current) {
            return;
        }


        const rect = sqlSyntaxBtnRef.current.getBoundingClientRect();

        const sqlSyntaxMenuHalfWidth = 71;
        const sqlSyntaxBtnHalfWidth = rect.width / 2;

        const left = rect.left + window.scrollX + sqlSyntaxBtnHalfWidth - sqlSyntaxMenuHalfWidth;

        return (
            <div
                className={`export-code-group`}
                ref={sqlSyntaxMenuRef}
                style={{ top: `${53}px`, left: `${left}px` }}
            >
                <div className="controls-group">
                    {/* <div className="control">
                        <button
                            className={`control-button hovered`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setSqlSyntax('basicsql'));
                            }}
                        >
                            Basic SQL
                        </button>
                    </div> */}

                    <div className="control">
                        <button
                            className={`control-button ${diagramDbEngine === 'mysql' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setSqlSyntax('mysql'));
                            }}
                        >
                            MySQL
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button ${diagramDbEngine === 'postgresql' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setSqlSyntax('postgresql'));
                            }}
                        >
                            PostgreSQL
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button ${diagramDbEngine === 'sqlserver' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setSqlSyntax('sqlserver'));
                            }}
                        >
                            SQL Server
                        </button>
                    </div>

                    <div className="control">
                        <button
                            className={`control-button ${diagramDbEngine === 'oracle' ? 'selected' : ''}`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            style={{ fontSize: '24px', fontWeight: 700 }}
                            onClick={() => {
                                dispatch(setSqlSyntax('oracle'));
                            }}
                        >
                            Oracle
                        </button>
                    </div>

                </div>
            </div>
        );
    };


    useEffect(() => {
        elementsRef.current = structuredClone(elementsRedux);
    }, [elementsRedux]);




    useEffect(() => {
        const handleDocumentClick = (event) => {
            // check if press any button exept 'left mouse button' then return nothing
            if (event.button !== 0) {
                return;
            }

            // check if 'settings menu enabled' and click outside of 'settings menu' and 'settings button'
            if (
                isBtnSettingsEnabled &&
                !settingsMenuRef.current?.contains(event.target) &&
                !settingsBtnRef.current?.contains(event.target)
            ) {
                dispatch(toggleBtnSettings());
            }

            // check if 'search menu enabled' and click outside of 'search menu' and 'search button'
            if (
                isBtnSearchEnabled &&
                !searchMenuRef.current?.contains(event.target) &&
                !searchBtnRef.current?.contains(event.target)
            ) {
                // dispatch(toggleBtnSearch());
            }

            // check if 'view modes menu enabled' and click outside of 'view modes menu' and 'view modes button'
            if (
                isBtnViewModesEnabled &&
                !viewModesMenuRef.current?.contains(event.target) &&
                !viewModesBtnRef.current?.contains(event.target)
            ) {
                dispatch(toggleBtnViewModes());
            }

            // check if 'export menu enabled' and click outside of 'export menu' and 'export button'
            if (
                isBtnExportEnabled &&
                !exportMenuRef.current?.contains(event.target) &&
                !exportBtnRef.current?.contains(event.target) &&
                !exportCodeMenuRef.current?.contains(event.target)
            ) {
                dispatch(toggleBtnExport());
            }

            // check if 'sql syntax menu enabled' and click outside of 'sql syntax menu' and 'sql syntax button'
            if (
                isBtnSqlSyntaxEnabled &&
                !sqlSyntaxMenuRef.current?.contains(event.target) &&
                !sqlSyntaxBtnRef.current?.contains(event.target)
            ) {
                dispatch(toggleBtnSqlSyntax());
            }

        };

        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [
        dispatch,
        isBtnSearchEnabled,
        isBtnViewModesEnabled,
        isBtnExportEnabled,
        isBtnSqlSyntaxEnabled,
        isBtnSettingsEnabled,
    ]);

    return (
        // <div className="controls_top_left" style={{ top: `${isBtnPopupNewsEnabled ? 66 : 9 }px`}}>
        <div className="controls_top_left" style={{ top: `${isBtnPopupNewsEnabled ? 58 : 9}px` }}>
            <div className="controls-row">

                {getSettingsMenu(isBtnSettingsEnabled)}

                {getSearchMenu(isBtnSearchEnabled)}
                {getViewModesMenu(isBtnViewModesEnabled)}
                {getPenMenu(isBtnPenEnabled)}

                {/* {getSqlSyntaxMenu(isBtnSqlSyntaxEnabled)} */}

                {getExportMenu(isBtnExportEnabled)}
                {getExportImageMenu(isBtnExportImageEnabled)}
                {getExportCodeMenu(isBtnExportCodeEnabled)}

                <div className="controls-group large">

                    {/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button back-link`}
                                    type="button"
                                    // title="Left Panel | [B]"
                                    // aria-label="Toggle Left Panel"
                                    aria-pressed="false"
                                    onClick={() => handleClick()}
                                >
                                    <IconBack />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls tooltip-back-link"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Back</span>
                                <Tooltip.Arrow className="tooltip-arrow" />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    <div className="control-divider" style={{ marginLeft: '1px' }}></div> */}




                    {/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild> */}
                    <div className="control">
                        <button
                            ref={settingsBtnRef}
                            className={`control-button settings ${isBtnSettingsEnabled && 'selected'}`}
                            type="button"
                            aria-pressed="false"
                            onClick={() =>
                                dispatch(toggleBtnSettings({}))
                            }
                        >
                            ≡
                        </button>
                    </div>
                    {/* </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls tooltip-back-link wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Settings</span>
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    <div className="control-divider" style={{ marginLeft: '1px' }}></div>

                    {isDesktop ?
                        <React.Fragment>
                            <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                                <Tooltip.Trigger asChild>
                                    <div className="control">
                                        <button
                                            className="control-button button-logo logo"
                                            type="button"
                                            aria-pressed="false"
                                            onClick={() => handleClick()}
                                        >
                                            {/* <img
                                        className="img-logo"
                                        src="/logo_dark2.png"
                                        alt="logo"
                                    /> */}
                                            {/* <LogoIcon /> */}
                                            <span
                                                className="span-logo logo-text"
                                                aria-hidden="true"
                                            >dbdesign.</span>
                                        </button>
                                    </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content
                                        className="tooltip-content tooltip-controls wo-shortcut"
                                        side="bottom"
                                        align="center"
                                        sideOffset={10}
                                    >
                                        <span>{t('t.ctrl_top_left.logo')}</span>
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>

                            <div className="control-divider"></div>
                        </React.Fragment>
                        : ''}


                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button button-logo title ${isModalDiagramDetailsEnabled ? 'selected' : ''}`}
                                    type="button"
                                    // title="Title"
                                    // aria-label="Title"
                                    aria-pressed="false"
                                    onClick={() =>
                                        dispatch(toggleDiagramDetails('canvas', diagramId))
                                    }
                                >
                                    <span
                                        className="span-logo"
                                        aria-hidden="true"
                                    >
                                        {/* {window.devicePixelRatio || 0} */}
                                        {diagramDetails?.title || ''}
                                    </span>
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctrl_top_left.name')}</span>
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild> */}
                    <div className="control">
                        <button
                            ref={sqlSyntaxBtnRef}
                            className={`control-button select_database ${(diagramDbEngine !== 'basicsql') ? 'selected' : ''}`}
                            type="button"
                            aria-pressed="false"
                            onClick={() => dispatch(toggleBtnSqlSyntax())}
                        >
                            {buildDbEngineName(diagramDbEngine)}
                        </button>
                    </div>
                    {/* </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>SQL Syntax & Functions</span>
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                </div>


                {isDesktop ?
                    <div className="controls-group">
                        <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                            <Tooltip.Trigger asChild>
                                <div className="control">
                                    <button
                                        disabled
                                        className={`control-button ${isBtnLeftPanelEnabled && 'selected'
                                            } disabled`}
                                        // className={`control-button ${isBtnLeftPanelEnabled && 'selected'}`}
                                        type="button"
                                        // title="Left Panel | [B]"
                                        // aria-label="Toggle Left Panel"
                                        aria-pressed="false"
                                        onClick={() =>
                                            dispatch(toggleBtnLeftPanel({}))
                                        }
                                    >
                                        {/* <LeftPanelOpenIcon /> */}
                                        {/* <LeftSidebarOpenedIcon /> */}
                                        <LeftSidebarClosedIcon />
                                    </button>
                                </div>
                            </Tooltip.Trigger>
                            <Tooltip.Portal>
                                <Tooltip.Content
                                    className="tooltip-content tooltip-controls"
                                    side="bottom"
                                    align="center"
                                    sideOffset={10}
                                >
                                    {/* <span>Editor Panel (soon)</span> */}
                                    <span>{t('t.ctrl_top_left.editor')}</span>
                                    <span className="tooltip-shortcut">B</span>
                                    {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                </Tooltip.Content>
                            </Tooltip.Portal>
                        </Tooltip.Root>

                        <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                            <Tooltip.Trigger asChild>
                                <div className="control">
                                    <button
                                        ref={searchBtnRef}
                                        disabled
                                        className={`control-button ${isBtnSearchEnabled && 'selected'} disabled`}
                                        // className={`control-button ${isBtnSearchEnabled && 'selected'}`}
                                        type="button"
                                        // title="Search | [F]"
                                        aria-label="Search"
                                        aria-pressed="false"
                                    // onClick={() =>
                                    //     dispatch(toggleBtnSearch({}))
                                    // }
                                    >
                                        <SearchIcon />
                                    </button>
                                </div>
                            </Tooltip.Trigger>
                            <Tooltip.Portal>
                                <Tooltip.Content
                                    className="tooltip-content tooltip-controls"
                                    side="bottom"
                                    align="center"
                                    sideOffset={10}
                                >
                                    <span>{t('t.ctrl_top_left.search')}</span>
                                    <span className="tooltip-shortcut">
                                        {shortKeysMap?.CTRL} + F
                                    </span>
                                    <span className="tooltip-shortcut">F</span>
                                    {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                </Tooltip.Content>
                            </Tooltip.Portal>
                        </Tooltip.Root>

                        <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                            <Tooltip.Trigger asChild>
                                <div className="control">
                                    <button
                                        ref={exportBtnRef}
                                        className={`control-button ${(isBtnExportEnabled ||
                                            isBtnExportImageEnabled ||
                                            isBtnExportCodeEnabled) &&
                                            'selected'
                                            }`}
                                        type="button"
                                        // title="Export | [E]"
                                        // title="Export By Image / SQL Code"
                                        // aria-label="Export"
                                        aria-pressed="false"
                                        onClick={() => dispatch(toggleBtnExport())}
                                    >
                                        <ExportIcon />
                                    </button>
                                </div>
                            </Tooltip.Trigger>
                            <Tooltip.Portal>
                                <Tooltip.Content
                                    className="tooltip-content tooltip-controls"
                                    side="bottom"
                                    align="center"
                                    sideOffset={10}
                                >
                                    <span>{t('t.ctrl_top_left.export')}</span>
                                    <span className="tooltip-shortcut">E</span>
                                    {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                                </Tooltip.Content>
                            </Tooltip.Portal>
                        </Tooltip.Root>
                    </div>
                    : ''}

                <div className="controls-group">

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    ref={viewModesBtnRef}
                                    className={`control-button ${(isBtnViewModesEnabled || viewMode !== 'full') && 'selected'}`}
                                    type="button"
                                    // title="View Mode: Physical / Logical / Keys"
                                    // aria-label="View Mode: Physical / Logical / Keys"
                                    aria-pressed="false"
                                    onClick={() =>
                                        dispatch(toggleBtnViewModes())
                                    }
                                >
                                    <ViewModeIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctrl_top_left.view_mode')}</span>
                                {/* <span className="tooltip-shortcut">E</span> */}
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>

                    {/* <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    aria-pressed="false"
                                    onClick={() => dispatch(updateScaleToFit())}
                                >
                                    <AutoLayoutIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Auto Layout</span>
                                <Tooltip.Arrow className="tooltip-arrow" />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root> */}

                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={600} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    className={`control-button`}
                                    type="button"
                                    // title="Zoom to Fit"
                                    // aria-label="Zoom to Fit"
                                    aria-pressed="false"
                                    onClick={() => dispatch(updateScaleToFit())}
                                >
                                    <FitToZoomIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls wo-shortcut"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{t('t.ctrl_top_left.zoom_to_fit')}</span>
                                {/* <span className="tooltip-shortcut">E</span> */}
                                {/* <Tooltip.Arrow className="tooltip-arrow" /> */}
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>

                {/* <div className="controls-group">
                    <div className="control">
                        <button
                            className={`control-button disabled`}
                            type="button"
                            title="Validation + Validation Tooltip like 'Warnings (2)' with report by click on it"
                            aria-label="Enable Validation"
                            aria-pressed="false"
                        >
                            <AutoLayoutIcon />
                        </button>
                    </div>

                    <Tooltip.Root
                        delayDuration={600}
                        disableHoverableContent
                    >
                        <Tooltip.Trigger asChild>
                            <div className="control">
                                <button
                                    disabled
                                    className={`control-button ${isBtnRedGreenViewEnabled &&
                                        'selected'
                                        } disabled`}
                                    type="button"
                                    // title="Red/Green View | [R]"
                                    // aria-label="4-Change View (PR)"
                                    aria-pressed="false"
                                    onClick={() =>
                                        dispatch(toggleBtnRedGreenView())
                                    }
                                >
                                    <ChangeRequestIcon />
                                </button>
                            </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls"
                                side="bottom"
                                align="center"
                                sideOffset={10}
                            >
                                <span>Red / Green View</span>
                                <span className="tooltip-shortcut">R</span>

                                <Tooltip.Arrow className="tooltip-arrow" />
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div> */}

            </div>
        </div>
    );
};

export default ControlsTopLeft;
